export const ACTION_ADD_PRIORITY_TO_CART = '/OsimCart/AddPriorityDeliveryCart';